import React from 'react';
import classnames from 'classnames';

import Element from 'components/Misc/Form/Type/Element';

const Type = ({ name, value, options, onChange, readOnly, className }) => {
	// Container's classnames
	const containerClassName = classnames(
		'flex gap-4 flex-wrap',
		className
	);

	return (
		<div className={containerClassName}>
			{options?.map(option =>
				<Element
					key={option.value}
					name={name}
					value={value}
					option={option}
					onChange={onChange}
					readOnly={readOnly}
				/>
			)}
		</div>
	);
};

export default Type;